import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Compass, ChatCircle, Heart, User } from '@phosphor-icons/react'
import './BottomNav.css'

const BottomNav = ({ activeTab, hasNewLikesBadge = false, hasNewChatsBadge = false }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  const goTo = (tab) => {
    const path = `/app/${tab}`
    if (location.pathname !== path) {
      navigate(path)
    }
  }

  const iconSize = 22
  return (
    <nav className="bottom-nav">
      <button
        className={`nav-item ${activeTab === 'people' ? 'active' : ''}`}
        onClick={() => goTo('people')}
      >
        <Compass size={iconSize} weight={activeTab === 'people' ? 'fill' : 'regular'} />
        <span>{t('nav.explore')}</span>
      </button>
      <button
        className={`nav-item ${activeTab === 'chats' ? 'active' : ''}`}
        onClick={() => goTo('chats')}
      >
        <span className="nav-item-icon-wrap">
          <ChatCircle size={iconSize} weight={activeTab === 'chats' ? 'fill' : 'regular'} />
          {hasNewChatsBadge && <span className="nav-item-badge" aria-hidden />}
        </span>
        <span>{t('nav.chats')}</span>
      </button>
      <button
        className={`nav-item ${activeTab === 'likes' ? 'active' : ''}`}
        onClick={() => goTo('likes')}
      >
        <span className="nav-item-icon-wrap">
          <Heart size={iconSize} weight={activeTab === 'likes' ? 'fill' : 'regular'} />
          {hasNewLikesBadge && <span className="nav-item-badge" aria-hidden />}
        </span>
        <span>{t('nav.likes')}</span>
      </button>
      <button
        className={`nav-item ${activeTab === 'profile' ? 'active' : ''}`}
        onClick={() => goTo('profile')}
      >
        <User size={iconSize} weight={activeTab === 'profile' ? 'fill' : 'regular'} />
        <span>{t('nav.profile')}</span>
      </button>
    </nav>
  )
}

export default BottomNav

